export enum MeridianLoanPurposeTextType {
	PURCHASE = 'Purchase',
	REFI_RATE_TERM = 'Refinance',
	REFINANCE_CASHOUT = 'Refinance Cashout',
	CONSTRUCTION = 'Construct',
	CONSTRUCTION_PERM = 'Construct Permanent',
	OTHER = 'Other',
	FHA_STREAMLINE_REFI = 'FHA Streamlined Refinance',
	VA_IRRRL = 'VA IRRRL',
	UNKNOWN = 'Unknown'
}